import React, { forwardRef, useCallback, useImperativeHandle, useState } from 'react';

import { styled } from 'netline-ui';

import PreferencesListItem from './PreferencesListItem';
import styles, { preferencesPopupClasses } from './PreferencesPopup.styles';

const PreferencesPopupRoot = styled('div', { name: preferencesPopupClasses.$name })(styles);

export type PreferencesPopupType = {
  closePopup?: () => void;
};

type PreferencesPopupProps = {
  children: React.ReactNode;
  title: string;
};

const PreferencesPopup = forwardRef<PreferencesPopupType, PreferencesPopupProps>(({ children, title }, ref) => {
  const [popupOpen, setPopupOpen] = useState(false);

  const closePopup = useCallback(() => {
    setPopupOpen(false);
  }, []);

  useImperativeHandle(ref, () => ({ closePopup }));

  const handleArrowClick = useCallback(() => {
    setPopupOpen(true);
  }, []);

  return (
    <PreferencesPopupRoot data-testid="PreferencesPopup-root">
      <PreferencesListItem title={title} handleClick={handleArrowClick} data-testid="PreferencesPopup-list-item" />
      {popupOpen && (
        <div className={preferencesPopupClasses.popup} data-testid="PreferencesPopup-list-item">
          {children}
        </div>
      )}
    </PreferencesPopupRoot>
  );
});

export default PreferencesPopup;
